import { faPen } from '@fortawesome/pro-light-svg-icons';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import { useFireAlertDelete } from 'hooks/useFireAlertDelete';
import * as ErpRecipe from 'types/Recipe/Detail/ErpNew/ErpRecipe';

type IProps = RecipeErpViewComponentProps & { erpRecipe: ErpRecipe.Type };

const AccordionBodyButtons = (props: IProps) => {
	const { classes } = useStyles();
	const { t } = useTranslation();

	const fireAlert = useFireAlertDelete();

	async function handleDelete(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		event.stopPropagation();
		fireAlert(() => props.handlers.deleteErpRecipe(props.erpRecipe.id));
	}

	async function handleEdit(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		event.stopPropagation();
		props.handlers.setErpRecipeId(props.erpRecipe.id);
	}

	return (
		<div className={classes.container}>
			<button type="button" className="btn btn-primary btn-sm" onClick={handleEdit}>
				<FontAwesomeIcon icon={faPen} size="lg" className={classes.button} />
				{t('_general:EDIT')}
			</button>
			<button type="button" className="btn btn-danger btn-sm" onClick={handleDelete}>
				<FontAwesomeIcon icon={faTrashCan} size="lg" className={classes.button} />
				{t('_general:DELETE')}
			</button>
		</div>
	);
};

export default AccordionBodyButtons;

export const useStyles = tss.create({
	container: {
		display: 'flex',
		gap: '10px',
	},
	button: {
		marginRight: '7px',
	},
});
